import React, { useCallback, useMemo } from 'react';

// enums
import paletteMapper from '../../../../../enums/paletteMappingEnum';

// components
import { MenuItem, TextField, Typography } from '@common-ui/ui';

//  TODO: MIGRATE PALETTE GRADIENTS TO OBJECT
import '../../../styles.css';

// constants
const PALETTE_DEFAULT = { id: 'PALSCHEME_GRAYSCALE', label: 'Grayscale' };

function buildUniqueValueArray(itemKeys = []) {
  // build list of only unique-valued items
  const uniqueDropdownItems = [];

  itemKeys.forEach((id) => {
    const label = paletteMapper[id];

    const isValueExists = uniqueDropdownItems.some((item) => item.value === label);

    if (!isValueExists) {
      uniqueDropdownItems.push({ id, label });
    }
  });

  // if uniqueDropdownItems is empty, add PALETTE_DEFAULT
  if (uniqueDropdownItems.length === 0) {
    uniqueDropdownItems.push(PALETTE_DEFAULT);
  }

  return uniqueDropdownItems;
}

export default function IRImagePaletteDropDown({
  value = PALETTE_DEFAULT.id,
  palettes = [],
  onChange = null,
}) {
  const handleChange = useCallback(
    (event) => {
      const nextValue = event.target.value;
      onChange?.({ paletteScheme: nextValue });
    },
    [onChange],
  );

  const palettesAvailable = useMemo(() => {
    // available palettes
    return buildUniqueValueArray(palettes);
  }, [palettes]);

  return (
    <TextField
      style={styles.palette}
      select
      label="Palette"
      value={value}
      onChange={handleChange}
      SelectProps={{
        MenuProps: {
          style: { maxHeight: 500 },
        },
      }}
    >
      {palettesAvailable.map(({ id, label }, index) => (
        <MenuItem key={index} value={id}>
          {paletteMapper[id] ? (
            <div style={styles.menuItem}>
              <Typography>{label}</Typography>
              <span style={styles.icon} className={`${label}`} />
            </div>
          ) : null}
        </MenuItem>
      ))}
    </TextField>
  );
}

const styles = {
  palette: {
    maxHeight: '400px',
  },
  icon: {
    border: '2px solid #d8d8d8',
    width: '35px',
    height: '35px',
    borderRadius: '50%',
    display: 'inline-block',
  },
  menuItem: {
    width: '100%',
    height: '25px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
};
